import { z } from "zod";
import { MetaSchema } from "./shared";
import { UserPurchasedPackSchema } from "./shared/UserPurchasedPackSchema";

export const WalletTransactionExtendedSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  isRenewedTransaction: z.boolean().nullable().optional(),
  isWithdrawRequested: z.boolean().nullable().optional(),
  type: z.string().nullable(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.number().nullable(),
  useGGold: z.string().nullable(),
  useProfit: z.string().nullable(),
  hash: z.string().nullable(),
  created_at: z.string().datetime(),
  completedAt: z.string().datetime().nullable(),
  status: z.string(),
  description: z.string().nullable(),
  userPurchasedPacks: z.array(UserPurchasedPackSchema).optional(),
  principleCapitalReturnReceived: z.number().optional(),
});

export const WalletsTransactionsDataSchema = z.tuple([
  z.array(WalletTransactionExtendedSchema),
  z.number(),
]);

const WalletsTransactionsResponse = z.object({
  data: WalletsTransactionsDataSchema,
  meta: MetaSchema.default,
});

export type WalletsTransactionsResponseType = z.infer<
  typeof WalletsTransactionsDataSchema
>;

export type UserPurchasedPackType = z.infer<typeof UserPurchasedPackSchema>;

export type WalletTransactionExtendedSchemaType = z.infer<
  typeof WalletTransactionExtendedSchema
>;

export default WalletsTransactionsResponse;
